export default "__VITE_ASSET__BMXcAcHi__"